import React, { cloneElement } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { ROUTES } from 'consts'
import { notification } from 'antd'
import { decodeJWT } from 'utils'

/**
 *
 * @param {Object} props
 * @param {Array<String>} props.permissions
 * @param {React.ReactChildren} props.children
 */
const Authentication = ({ permissions, title, children, ...props }) => {
  const navigate = useNavigate()
  const payload = decodeJWT(localStorage.getItem('refreshToken'))
  //modify title
  document.title = title

  //check đã đăng nhập chưa hoặc token còn hạn -> vào trang home
  if (!permissions) {
    if (!payload || new Date(payload.exp * 1000).getTime() < Date.now()) {
      return cloneElement(children, props)
    }
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  //check login ?
  if (!payload) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  // Support both 'permission' (singular) and 'permissions' (plural) fields in JWT
  const userPermissions = Array.isArray(payload.permission)
    ? payload.permission
    : Array.isArray(payload.permissions)
    ? payload.permissions
    : []

  // permissions.length = 0 -> screen public
  // permissions.length > 0 -> check user có quyền truy cập vào màn hình này
  if (
    permissions.length === 0 ||
    permissions.filter((p) => userPermissions.includes(p)).length > 0
  ) {
    return cloneElement(children, props)
  }

  notification.warning({
    message: 'Permission Denied',
  })

  navigate(-1)

  return <div />
}

export default Authentication
